import {
  Component,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  AfterContentChecked,
  Optional,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { JoyrideService } from 'ngx-joyride';

import { FitnessPlanData, ProgramTemplateData } from '../../../../@core/interfaces/common/CalorieFriend/plan';
import { PatientData } from '../../../../@core/interfaces/common/CalorieFriend/patients';
import { UsersService } from '../../../../@core/backend/common/services/users.service';
import { User } from 'app/@core/interfaces/common/users';
import {
  TutorialData,
  TutorialIDs,
} from 'app/@core/interfaces/common/CalorieFriend/tutorial';
import { FitnessPlanDefComponentBase } from './fitness-plan-def-base.component';

/**
 * Component to edit plan data on the 'Edit Template' page.
 * Inherits from the PlanDefComponentBase component.
 */
@Component({
  selector: 'app-fitness-plan-def',
  templateUrl: './fitness-edit-plan-def.component.html',
  styleUrls: [
    './fitness-plan-def.component.scss',
    '../../global.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class FitnessPlanDefComponent
  extends FitnessPlanDefComponentBase
  implements OnInit {
  constructor(
    @Optional() protected PlanDefDialogRef: NbDialogRef<any>,
    private PlanDefRoute: ActivatedRoute,
    private PlanDefToasterService: NbToastrService,
    private PlanDefLocation: Location,
    PlanDefFormBuilder: FormBuilder,
    PlanDefDialogService: NbDialogService,
    PlanDefPlanService: FitnessPlanData,
    PlanDefUsersService: UsersService,
    PlanDefRouter: Router,
    PlandDefPatientService: PatientData,
    programTempalteService: ProgramTemplateData,
  ) {
    super(
      PlanDefRoute,
      PlanDefFormBuilder,
      PlanDefDialogService,
      PlanDefPlanService,
      PlanDefToasterService,
      PlanDefUsersService,
      PlanDefRouter,
      PlandDefPatientService,
      programTempalteService
    );

    this.ref = PlanDefDialogRef;

    const templateData = this.PlanDefRoute.snapshot.data.templateData;

    if (templateData && templateData.template) {
      this.EditingTemplate = true;
      this.ThePlan = templateData.template.thePlan;
      this.TheTemplateID = templateData.template.id;
      this.TheTemplateIsPublic = templateData.template.isPublic;
      this.templateUserID = templateData.template.userID;
      this.ThePlan.name = templateData.template.name;
      this.ThePlan.description = templateData.template.description;
      this.TheTemplateName = templateData.template.name;
      this.TheTemplateDescription = templateData.template.description;
    }
  }


  onSavePlan(): void {
    super.SavePlan();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.PatientShortHandName = "Templates"
    if (
      this.ThePlan != null &&
      (this.ThePlan.days == null || this.ThePlan.days.length === 0)
    ) {
      this.NewDay();
    }
  }

  ProblemSavingTemplate = 'Problem updating template';
  TemplateUpdated = 'Template Updated';

  /**
   * Event handler of Success event of Updating a template.
   */
  handleSuccessResponse() {
    this.PlanDefToasterService.success('', `${this.TemplateUpdated}!`);
  }

  /**
   * Event handler of Fail event of Updating a template.
   */
  handleWrongResponse(data: any) {
    this.PlanDefToasterService.danger('', this.ProblemSavingTemplate);
  }

  /**
   * Method to close the container dialog if it is opened in pop up dialog
   * or navigates back to the PatientSheetView page
   */
  Back() {
    this.PlanDefLocation.back();
  }
}

/**
 * Component for the Edit Plan page.
 * Inherits from the PlanDefComponentBase component.
 */
@Component({
  selector: 'app-fitness-plan-edit',
  templateUrl: './fitness-edit-plan-def.component.html',
  styleUrls: [
    './fitness-plan-def.component.scss',
    '../../global.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class EditFitnessPlanDefComponent
  extends FitnessPlanDefComponentBase
  implements OnInit, AfterContentChecked {
  @ViewChild('EditView', { read: ElementRef }) private EditView: any = null;

  constructor(
    private PlanDefRoute: ActivatedRoute,
    protected PlanDefDialogRef: NbDialogService,
    private PlanDefPlanService: FitnessPlanData,
    private PlanDefCdRef: ChangeDetectorRef,
    PlanDefFormBuilder: FormBuilder,
    PlanDefDialogService: NbDialogService,
    PlanDefToasterService: NbToastrService,
    PlanDefUsersService: UsersService,
    PlanDefRouter: Router,
    PlandDefPatientService: PatientData,
    programTemplateService: ProgramTemplateData,
  ) {
    super(
      PlanDefRoute,
      PlanDefFormBuilder,
      PlanDefDialogService,
      PlanDefPlanService,
      PlanDefToasterService,
      PlanDefUsersService,
      PlanDefRouter,
      PlandDefPatientService,
      programTemplateService
    );

    this.ref = PlanDefDialogRef;
  }

  ngAfterContentChecked() {
    this.PlanDefCdRef.detectChanges();
  }

  ngOnInit(): void {
    // get the plan by the id from the query
    const id = this.PlanDefRoute.snapshot.paramMap.get('PlanId');
    this.PlanDefPlanService.get(+id).subscribe((data) => {
      this.ThePlan = data;
      //this.PlanID = data.id;
      this.PatientID = data.patientID;

      super.ngOnInit();
    });
  }

  onSavePlan() {
    this.SavePlan();
  }
}

/**
 * Component for the Add Plan page.
 */
@Component({
  selector: 'app-fitness-template-def',
  templateUrl: './fitness-edit-plan-def.component.html',
  styleUrls: [
    './fitness-plan-def.component.scss',
    '../../global.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class AddFitnessPlanDefComponent
  extends FitnessPlanDefComponentBase
  implements OnInit {
  constructor(
    private PlanDefRoute: ActivatedRoute,
    protected PlanDefDialogRef: NbDialogService,
    public joyrideService: JoyrideService,
    private tutorialService: TutorialData,
    PlanDefFormBuilder: FormBuilder,
    PlanDefDialogService: NbDialogService,
    PlanDefPlanService: FitnessPlanData,
    PlanDefToasterService: NbToastrService,
    PlanDefUsersService: UsersService,
    PlanDefRouter: Router,
    PlandDefPatientService: PatientData,
    programTemplateService: ProgramTemplateData,
  ) {
    super(
      PlanDefRoute,
      PlanDefFormBuilder,
      PlanDefDialogService,
      PlanDefPlanService,
      PlanDefToasterService,
      PlanDefUsersService,
      PlanDefRouter,
      PlandDefPatientService,
      programTemplateService
    );

    this.ref = PlanDefDialogRef;
    this.ThePlan = null;
  }

  currentUser: User = null;

  ngOnInit(): void {
    super.ngOnInit();
    this.NewDay();

    this.currentUserSubject.subscribe((user) => {
      if (user == null) return;

      this.currentUser = user;

      const isFromTutorial =
        this.PlanDefRoute.snapshot.url.length > 2
          ? this.PlanDefRoute.snapshot.url[2].toString().toLowerCase() ===
          'fromtutorial'
          : false;

      const tutorialStates = JSON.parse(user.tutorialStates ?? '{}');
      const steps = [];

      // check the tutorial step 5 - New Plan
      if (!tutorialStates[TutorialIDs.LoadFromTemplate] && isFromTutorial) {
        this.inTutorial = true;

        // for (let i = 0; i < 4; i++) steps.push('');

        steps.push(TutorialIDs.LoadFromTemplate);

        // fill the fake steps to make step numbers correct
        // for (let i = 0; i < 2; i++) steps.push('');

        setTimeout(() => {
          this.joyrideService
            .startTour(
              {
                steps: steps,
                showPrevButton: false,
                showCounter: true,
              } // Your steps order
            )
            .subscribe(
              (step) => {
                /*Do something*/
                this.inTutorial = step.name === TutorialIDs.LoadFromTemplate;
              },
              (error) => {
                /*handle error*/
              },
              () => {
                /*Tour is finished here, do something*/
              }
            );
        }, 1000);
      }
    });
  }

  onSavePlan() {
    this.joyrideService.closeTour();

    this.SavePlan();

    const isFromTutorial =
      this.PlanDefRoute.snapshot.url.length > 2
        ? this.PlanDefRoute.snapshot.url[2].toString().toLowerCase() ===
        'fromtutorial'
        : false;

    if (isFromTutorial) {
      this.tutorialService.save(TutorialIDs.FinalStep).subscribe(() => { });
    }

    this.inFinalTutorial = false;
  }

  SelectTemplate() {
    this.inTutorial = false;

    const isFromTutorial =
      this.PlanDefRoute.snapshot.url.length > 2
        ? this.PlanDefRoute.snapshot.url[2].toString().toLowerCase() ===
        'fromtutorial'
        : false;

    super.SelectTemplate(isFromTutorial, this.currentUser);

    // save tutorial position
    this.tutorialService.save(TutorialIDs.LoadFromTemplate).subscribe(() => { });

    this.joyrideService.closeTour();

    this.selectTemplateSubject.subscribe((plan) => {
      if (plan) {
        const tutorialStates = JSON.parse(
          this.currentUser.tutorialStates ?? '{}'
        );

        // final tutorial step
        if (!tutorialStates[TutorialIDs.FinalStep] && isFromTutorial) {
          const steps = [TutorialIDs.FinalStep];

          this.inFinalTutorial = true;

          setTimeout(() => {
            this.joyrideService
              .startTour(
                {
                  steps: steps,
                  showPrevButton: false,
                  showCounter: false,
                } // Your steps order
              )
              .subscribe(
                (step) => {
                  /*Do something*/
                  this.inFinalTutorial = step.name === TutorialIDs.FinalStep;
                },
                (error) => {
                  /*handle error*/
                },
                () => {
                  /*Tour is finished here, do something*/
                }
              );
          }, 1000);
        }
      }
    });
  }
}
